module.exports = __webpack_public_path__ + "img/img21.0cccf815.svg";